/**
 * @author NikolaV
 */

import { FeatureMouseInteraction } from '@openlayers/interaction/FeatureMouseInteraction';
import { MapOverlays } from '@openlayers/ol-overlays';
import { declusterFeature, isCluster, setMapCursor } from '@openlayers/ol-utils';
import { mapWrapper } from '@pages/map/map';
import { DateUtils } from '@shared/utils/DateUtils';
import { getFilenameWithVersion } from '@shared/utils/utils';
import Feature from 'ol/Feature';


export class DocumentDesktopMouseInteraction extends FeatureMouseInteraction {

    onClick = (feature: Feature, e, n): void => {
        // clicked cluster > print list of documents inside
        if (isCluster(feature)) {
            const clusterFeatures: Feature[] = feature.get('features');
            const [lat, lon] = clusterFeatures[0].getGeometry().getExtent();

            const ul = $('<div class="images-cluster-list" style="min-width: 300px; max-height: 400px;">');
            const sortedDocs = clusterFeatures
                .map((f) => f.get('data'))
                .sort((a: IDocument, b: IDocument) => {
                    return (
                        (b.timestamp || b.originalDate) -
                        (a.timestamp || a.originalDate)
                    )
                })

            const lis = clusterFeatures
                .map(f => f.get('data'))
                .sort((a: IDocument, b: IDocument) => b.timestamp - a.timestamp)
                .map((data: IDocument) => {
                    const li = $(
                        `<div onclick="event.stopPropagation(); mapWrapper.featureLayers.documents.openDocumentById(${data.id}, [${sortedDocs.map((f) => f.id)
                            .join(',')}])"><span>${getFilenameWithVersion(data)}</span></div>`
                    )
                    if (kuura.hasPrivilege('MODEL_PAGE')) {
                        li.append(`<button onclick="event.stopPropagation(); mapUI.editDocument(${data.id})" class="right ik-button-small ik-button-secondary--subtle"><i class="iki iki-edit"></i></button>`);
                    }
                    ul.append(li);
                });

            const dialog = MapOverlays.showDialog(this.map, ul, lat, lon, feature);
        }
        // clicked single unclastered image
        else if (feature) {
            mapWrapper.featureLayers.documents.openDocumentById(feature.get('data')?.id);
        }
    };

    onMouseOver = (feature: Feature, e, n): void => {
        setMapCursor(this.map, 'pointer');
        if (!feature || isCluster(feature)) return;

        feature = declusterFeature(feature);
        const data = feature.get('data');
        const { creator, timestamp, reportTemplate, ...rest } = data;
        if (data.name) {
            MapOverlays.showTooltip(this.map, `<div class="popup no-break-text" style="padding: 10px">${getFilenameWithVersion(data)}
<br/>${DateUtils.formatDateTime(timestamp)}
<br/>${kuura.getMessage('general.description')}: ${data?.description}
<br/>${kuura.getMessage('general.user')}: ${creator?.username ?? '/'}
<br/>${reportTemplate ? kuura.getMessage('js_project.template_name') + ': ' + reportTemplate.name : ''}
</div>`, e, n);
        }
    };
}
